export enum AppraiserLicenseType {
    Licensed = 1,
    Residential = 2,
    General = 3,
}
